import type {ReactElement} from 'react';
import {Text} from '@Components/text';
import styles from './new-feature-badge.module.scss';

export function NewFeatureBadge(): ReactElement {
  return (
    <div className={styles.badgeWithShadow}>
      <div className={styles.newFeatureBadge}>
        <Text val={window.i18next.t('pmwjs_new')} className={styles.text} />
      </div>
      <div className={styles.pillShadow} />
    </div>
  );
}
